import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import SubRow from './sub-row';

@inject('artistStore', 'songsStore')
@observer
class SubList extends Component {
	componentDidMount () {
		this.props.artistStore.fetchIfEmpty();
		
	}
	render () {
		const { artistStore, subscriptions, showCancelled } = this.props;
	
		if (artistStore.isLoading) {
			if(_.isEmpty(subscriptions) || artistStore.items.length <= 0) {
				 return null;
			}
		}


		console.log(subscriptions);
		return (
			<div className="song-list">
				<div className="grid-x align-left song-header-row">
					<div className="cell small-1">
						
					</div>
					<div className="cell small-3">
						Artist
					</div>

					<div className="cell small-3">
						Subscribe Date
					</div>

					<div className="cell small-3 text-center">
						Renewal Date
					</div>

					<div className="cell small-2">
					</div>
				</div>

				{!showCancelled && (
					subscriptions.filter(s => s.active !== false).map(
						(s, index) =>
						{
							let artist = artistStore.getItemByID(s.artistID);
							console.log(artist);
							return (
								<SubRow
									key={ s.id }
									subscriptionId={ s.id }
									index={ index }
									artist={ artist }
									createdAt={ s.createdAt }
									currentPeriodEnd={ s.currentPeriodEnd }
								/>
							)
						}
					)
				)}

				{showCancelled && (
					subscriptions.filter(s => s.active === false).map(
						(s, index) => {
							const artist = artistStore.getItemByID(s.artistID);
							console.log(artist);
							return (
								<SubRow
									key={ s.id }
									index={ index }
									artist={ artist }
									createdAt={ s.createdAt }
									currentPeriodEnd={ s.currentPeriodEnd }
								/>
							);
						}
					)
				)}
			</div>
		);
	}
}

export default SubList;
